// services/childcare/index.js

import * as auth from "./auth";
import * as registration from "./registration";
import * as profile from "./profile";
import * as children from "./children";
import * as programs from "./programs";
import * as staff from "./staff";
import * as attendance from "./attendance";
import * as activities from "./activities";
import * as parentNotes from "./parent-notes";
import * as admins from "./admins";
import * as reports from "./reports";
import * as payments from "./payments";
import * as notifications from "./notifications";
import * as facility from "./facility";
import * as messages from "./messages";
import * as dashboard from "./dashboard";
import * as incidentReports from "./incident-reports";
import * as utils from "./utils";
import * as helpdesk from "./helpdesk";
import * as reviews from "./reviews";
import * as refund from "./refund";
import * as reportIssue from "./reportIssue";

// ==================== EXPORTS ====================

// Export utilities
export * from "./utils";

// Export auth services
export * from "./auth";

// Export registration services
export * from "./registration";

// Export profile services
export * from "./profile";

// Export children services
export * from "./children";

// Export programs services
export * from "./programs";

// Export staff services
export * from "./staff";

// Export attendance services
export * from "./attendance";

// Export activities services
export * from "./activities";

// Export parent notes services
export * from "./parent-notes";

// Export reports services
export * from "./reports";

// Export payments services
export * from "./payments";

// Export notifications services
export * from "./notifications";

// Export messages services
export * from "./messages";

// Export dashboard services
export * from "./dashboard";

// Export incident reports services
export * from "./incident-reports";

// Export helpdesk services
export * from "./helpdesk";

export * from "./facility";

export * from "./admins";

export * from "./reviews";

export * from "./refund";

export * from "./reportIssue";

// ==================== DEFAULT EXPORT ====================
const childcareService = {
  ...auth,
  ...registration,
  ...profile,
  ...children,
  ...programs,
  ...staff,
  ...attendance,
  ...activities,
  ...parentNotes,
  ...reports,
  ...payments,
  ...notifications,
  ...messages,
  ...dashboard,
  ...incidentReports,
  ...utils,
  ...helpdesk,
  ...facility,
  ...admins,
  ...reviews,
  ...facility,
  ...refund,
  ...reportIssue,
};
export default childcareService;
